"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _types = require("@kyruus/types");
var _styles = _interopRequireDefault(require("./styles"));
var _images = require("../../lib/images");
var _logoImage = _interopRequireDefault(require("../LogoImage/logo-image"));
const ProviderLogos = _ref => {
  let {
    provider,
    logoConfigs,
    facets
  } = _ref;
  /**
   * Method to turn a logo object into a LogoImage
   * @param {object} logo Object describing a logo
   * @return {JSX} LogoImage component for the passed in logo
   */
  const logoImageCreator = _ref2 => {
    let {
      logo_url: logoUrl,
      logo_name: logoName
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_logoImage.default, {
      key: `${logoUrl}:${logoName}`,
      url: logoUrl,
      affiliation: logoName
    });
  };

  // Get the logos for the provider
  const logos = (0, _images.getProviderLogoObjects)(provider, logoConfigs, facets, _types.PMCLogoSections.SEARCH);
  return /*#__PURE__*/_react.default.createElement(_styles.default, null, (0, _map.default)(logos).call(logos, logoImageCreator));
};
var _default = exports.default = ProviderLogos;
ProviderLogos.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderLogos"
};